import { IconProps } from "./Icon.model";

export function UserIcon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3063 15.3372C18.4226 15.4064 18.5663 15.4875 18.729 15.5793C19.4418 15.9814 20.5193 16.5893 21.2575 17.3118C21.7191 17.7637 22.1578 18.3592 22.2375 19.0888C22.3223 19.8646 21.9839 20.5927 21.3048 21.2396C20.1334 22.3556 18.7276 23.25 16.9093 23.25H8.09104C6.27274 23.25 4.86695 22.3556 3.6955 21.2396C3.01649 20.5927 2.67802 19.8646 2.76283 19.0888C2.84257 18.3592 3.28123 17.7637 3.7429 17.3118C4.48106 16.5893 5.55857 15.9814 6.27139 15.5793C6.43404 15.4875 6.57773 15.4064 6.69404 15.3372C10.2481 13.2209 14.7523 13.2209 18.3063 15.3372Z"
        fill={fillColor}
      />
      <path
        d="M7.25018 7C7.25018 4.1005 9.60068 1.75 12.5002 1.75C15.3997 1.75 17.7502 4.1005 17.7502 7C17.7502 9.89949 15.3997 12.25 12.5002 12.25C9.60068 12.25 7.25018 9.89949 7.25018 7Z"
        fill={fillColor}
      />
    </svg>
  );
}
